module.exports = __webpack_public_path__ + "img/hr-sand-rock-small-13.bde6afae.png";